import React, {useCallback, useContext, useEffect, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {AppContext} from "../../../../App";
import {useForm, FormProvider} from "react-hook-form";
import {ProtocolliContext} from "./ProtocolloDetailPage";
import clsx from "clsx";
import {Card, CardActions, CardContent, CardHeader, MenuItem, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import CustomDateInput from "../../../widgets/inputs/CustomDateInput";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import CustomSelect from "../../../widgets/inputs/CustomSelect";
import CustomText from "../../../widgets/inputs/CustomText";
import FileInput from "../../carico/utils/FileInput";
import {getProtocolloById, protocollaProtocollo, scaricaProtocollo} from "../../../../services/QuaranteneServices";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {useParams} from "react-router-dom";

const ProtocolloDetailCard = () => {
	const classes = BaseStyle();
	const appContext = useContext(AppContext);
	const protocolloContext = useContext(ProtocolliContext);
	const methods = useForm({
		mode: "onChange",
		defaultValues: protocolloContext.state.protocollo,
	});
	const [submit, setSubmit] = useState(false);
	let {id} = useParams();
	
	const onSubmit = useCallback((data) => {
		if (!data.ProtocolloPDF) {
			setOpenSnackbar("warning", "Hey, non ti stai dimenticando di allegare il file del protocollo?", appContext.dispatch)
		} else {
			setSubmit(true);
			let newProtocollo = {
				...protocolloContext.state.protocollo,
				...data,
			}
			console.log(newProtocollo)
			protocollaProtocollo(newProtocollo, protocolloContext.dispatch);
		}
	}, [protocolloContext.state.protocollo, appContext.dispatch, protocolloContext.dispatch])
	
	useEffect(() => {
		if (submit && !protocolloContext.state.loadingProtocolla && protocolloContext.state.errorProtocolla === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Protocollo aggiornato con successo", appContext.dispatch);
			getProtocolloById(id, protocolloContext.dispatch);
		} else if (submit && !protocolloContext.state.loadingProtocolla && protocolloContext.state.errorProtocolla !== "") {
			setSubmit(false);
			setOpenSnackbar("error", protocolloContext.state.errorProtocolla, appContext.dispatch);
		}
	}, [submit, protocolloContext.state.loadingProtocolla, protocolloContext.state.errorProtocolla, appContext.dispatch, protocolloContext.dispatch, id])
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography
						variant={"h6"}><b>Dettaglio protocollo</b></Typography>}/>
				<CardContent style={{flexGrow: 1}}>
					<form onSubmit={methods.handleSubmit(onSubmit)}>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={6}>
								<CustomDateInput
									name={"dataProtocollo"}
									label={"Data protocollo"}
									control={methods.control}
									defaultValue={null}
									rules={{required: true}}
									error={methods.errors["dataProtocollo"]}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<CustomSelect
									label={"Stato"}
									control={methods.control}
									autoFocus={false}
									defaultValue={"Da protocollare"}
									rules={{required: true}}
									name={"stato"}
									error={methods.errors["stato"]}
								>
									{["Da protocollare", "Preso in carico", "Protocollato", "Generato PDF"].map((val, key) => {
										return (
											<MenuItem value={val} key={key}>
												{val}
											</MenuItem>
										);
									})}
								</CustomSelect>
							</Grid>
							<Grid item xs={12}>
								<CustomText
									type={"number"}
									control={methods.control}
									rules={{required: true}}
									label={"Numero protocollo"}
									autoFocus={false}
									name={"numeroProtocollo"}
									error={methods.errors["numeroProtocollo"]}
								/>
							</Grid>
							<Grid item xs={12}>
								<FormProvider {...methods}>
									<FileInput
										accept={"application/pdf"}
										multiple={false}
										name='ProtocolloPDF'
									/>
								</FormProvider>
							</Grid>
						</Grid>
					</form>
				</CardContent>
				<CardActions className={classes.flexRight}>
					<Tooltip
						title={"Se esiste (perché lo hai già caricato) scarica il protocollo che hai precedentemente inserito"}>
						<Button variant={"text"} disableElevation size="small"
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={() => scaricaProtocollo(id)}>
							<b>Scarica protocollo</b>
						</Button>
					</Tooltip>
					<Tooltip
						title={"Modifica le date di inzio e fine della quarantena"}>
						<Button variant={"contained"} disableElevation size="small" color={"primary"}
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={methods.handleSubmit(onSubmit)}>
							<b>Aggiorna informazioni</b>
						</Button>
					</Tooltip>
				</CardActions>
			</Card>
		</React.Fragment>
	);
};

export default React.memo(ProtocolloDetailCard);
